export default __webpack_public_path__ + "static/media/956.539c6d7d.png";